import { Box } from '@mui/material';
import { Route, Routes } from 'react-router';

import { ROUTES } from '@/layouts/routes/routes';
import { NotFound } from '@/views/generalError/notFound/NotFound.comp.tsx';

import { RouteGuard } from './RouteGuard.comp';

export const AppRoutes = () => {
  return (
    <Box width="100%">
      <Routes>
        <Route element={<NotFound />} path="*" />
        {ROUTES.map(({ component, path, roles }) => (
          <Route
            element={<RouteGuard rolesWithAccess={roles}>{component}</RouteGuard>}
            key={path}
            path={path}
          />
        ))}
      </Routes>
    </Box>
  );
};
